import React, { useEffect, useLayoutEffect, useState } from 'react';
import injectionWindow, { TLang } from '@/utils/lang';
import { connect } from 'dva';
import { PersistGate } from 'redux-persist/integration/react';
import 'zarm/dist/zarm.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './index.less';
import homeReq from '@/entity/module/home/homeAPi';
import { IProps } from '@/entity';
import NavIndex from '@/components/NavIndex';
import routers from '@/routers/index';
import { unionFlag, getSessonStorage, setSessonStorage, getLocalStorage, getQueryString, errorLog, checkUnifyShop } from '@/utils/index';
// default, 750px design draft
// src/hd.(tsx|ts|js|jsx)
import vw from 'umi-hd/lib/vw';
import flex from 'umi-hd/lib/flex';
import { Spin } from 'antd';
import { Toast } from 'antd-mobile';

import { BFD_checkApp, loadFUNJS, BFD_appGetCityInfo } from '@/utils/bfdApp';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import * as device from '@/utils/device';
import Cookies from 'js-cookie';
import locationApi from '@/entity/module/locationApi';
import eHome from '@/utils/eHome';
import { checkXcx } from '@/utils/checkXcx';
import CityCover from '@df-mobile/city-cover';
import _ from 'lodash';
import { safeJsonParse } from '@/utils/safeJsonParse';

var isReloadCity: any;
// import 'normalize.css/normalize.css' // 现代浏览器的 reset
const Layout: React.FC = (props: IProps) => {
  // Fix document undefined when ssr. #2571
  if (typeof document !== 'undefined') {
    window.devicePixelRatio = 1;
    if (document.documentElement.clientWidth >= 750) {
      vw(50, 375);
    } else {
      flex(100, document.documentElement.clientWidth/ 375);
    }

    //   // hd solution for antd-mobile@2
    //   // ref: https://mobile.ant.design/docs/react/upgrade-notes-cn#%E9%AB%98%E6%B8%85%E6%96%B9%E6%A1%88
    document.documentElement.setAttribute('data-scale', true);
  }
  const { dispatch, unionConfig, history } = props;
  const [loading, setLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);

  const initData = async() => {
    initBFDInfo();
    // checkLogin 检查登录状态 其他页面也需要登录状态，存 redux
    // 检查登录状态。  loginurl  loginFlag
    homeReq.getLoginStatus().then((res) => {
      dispatch && dispatch({
        type: 'initData/setLoginStatus',
        payload: res
      });
      // console.log('checkLogin');
    });
    console.log('initLoactionCity');
    const _env = DFWebUtilsTools.DF_Tools_CheckEnv();
    const _add =  await DFWebUtilsTools.initAddressDF(true, (data) => {
      if(data.code===0){
        setSessonStorage('systemLoaction', JSON.stringify({ location:data.location }));
        props.dispatch && props.dispatch({
          type: 'cinema/setIsShowKM',
          payload: true
        });
      }else{
        setSessonStorage('systemLoaction', '');
        props.dispatch && props.dispatch({
          type: 'cinema/setIsShowKM',
          payload: false
        });
      }
    }, false, '', true);
    const address = {
      cityId: _add?.cityId,
      cityName: _add?.cityName,
      name: _add?.cityName
    };
    console.log('getAddressById', address, _add);
    dispatch && dispatch({
      type: 'initData/setAddress',
      payload: address
    });
    getCityListInfo( _add?.cityId);
    // initLoactionCity(isApp);
    // injectionWindow()

  };


  // 获取城市数据
  const getCityListInfo = (cityId) => {
    homeReq.getCityList(cityId)?.then((Data: any) => {
      // 存入cityList
      const cityList = Data.cityList;
      setSessonStorage('cityList', JSON.stringify(cityList));
    });
  };

  /**
   * 初始化百福得信息
   */
  const initBFDInfo = () => {
    const union = unionFlag() || getSessonStorage('dffl_union') || getQueryString('union');

    if (!checkUnifyShop()) {
    if (!union || typeof union === 'undefined') {
      return;
    }}
    // 获取百福德配置信息   icon 和 scale
    homeReq.getUnionConfig()?.then((data) => {
      dispatch && dispatch({
        type: 'initData/setUnionConfig',
        payload: data
      });
    });
    homeReq.getUnionNewConfig()?.then((data) => {
      dispatch && dispatch({
        type: 'initData/setUnionConfig',
        payload: {
          hamburgerSwitch: data?.hamburgerSwitch,
          showHomePage: data?.showHomePage
        }
      });
    });
    /** 百福德配置 */
    // findByUnion: prefixStr + '/mallUnion/unionConfig/findByUnion',
    homeReq.findByUnion()?.then(({ Data }) => {
      dispatch && dispatch({
        type: 'initData/setUnionConfig',
        payload: Data
      });
      //findByUnion?.mallUnionConfigDto?.isBilingual
      const isBili = Data.mallUnionConfigDto?.isBilingual;
      setSessonStorage('isBilingual', isBili);

      try {
        const name = getLocalStorage('unionName');
        // window.document.title = Data?.mallUnionConfigDto?.customerName || name || '';
      } catch (error) {
        // window.document.title = Data?.mallUnionConfigDto?.customerName || '';
      }
    });

    // 获取   h5ShopLogo  logo
    homeReq.getLogo()?.then((data: any) => {
      // console.log('data',data)
      dispatch && dispatch({
        type: 'initData/setUnionConfig',
        payload: {
          logo: data.h5ShopLogo || data.logo,
          h5HomeIndex: data.h5HomeIndex
        }
      });
      // TODO: 添加usercenter;
      dispatch && dispatch({
        type: 'order/setUserCenter',
        payload: data.h5UserCenter
      });

      dispatch && dispatch({
        type: 'initData/setMenus',
        payload: {
          h5UserCenter: data.h5UserCenter || '/tmall/user',
          h5HomeIndex: data.h5HomeIndex || '/tmall/home',
          h5ShoppingCart: data.h5ShoppingCart || '/tmall/shopping/cart'
        }
      });
    });
  };

  const reloadCity = () => {
    if (initLoading) {
      Toast.info('定位失败,请手动选择城市', 2, () => {
        setInitLoading(false);
        props.dispatch &&
          props.dispatch({
            type: 'initData/setShowAddrPage',
            payload: true
          });
        props.dispatch &&
          props.dispatch({
            type: 'cinema/setIsShowKM',
            payload: false
          });
        if (props.history.location.pathname !== '/') {
          props.history.push('/');
        }
      });

    }
  };

  useEffect(() => {
    // console.log('initData111111111111');
    try {
      const currEnv = DFWebUtilsTools.DF_Tools_CheckEnv();
      if (currEnv === 'dingtalk') {
        DFWebUtilsTools.DF_Tools_GetDDAuth().then((r) => {
          initData();
          try {
            DFWebUtilsTools.getLocationPoiUpload();
          } catch (error) {
            console.log('getLocationPoiUpload -- error');
          }
        });
      }else if (currEnv === 'wx' || currEnv === 'qywx') {
        DFWebUtilsTools.DF_Tools_GetWXAuth().then((r) => {
          initData();
          try {
            DFWebUtilsTools.getLocationPoiUpload();
          } catch (error) {
            console.log('getLocationPoiUpload -- error');
          }
        });
      }else {
        initData();
      }
    } catch (ex) {
      // do nothing
    }

    const union = unionFlag() || getSessonStorage('dffl_union') || getQueryString('union');
    if (!union || typeof union === 'undefined') {
      // window.document.title = TLang('东方福利网', 'home', false, false, null);
      return;
    }
  }, []);

  useEffect(() => {
    const union = unionFlag() || getSessonStorage('dffl_union') || getQueryString('union');
    const isXcx = checkXcx();
    if (!union) return;
      // TODO：仅添加需要展示页，如果没有需要展示的此处添加屏蔽判断
      // if('/newBirthday/couponList'.includes((history.location.pathname))) {
      //   return eHome.clear()
      // }
    const debounceMX = _.debounce(() => {
      locationApi.findUnionBuoy({
        unionId: unionConfig?.mallUnionConfigDto?.unionId || '0'
      }).then((res: any) => {
        const {
          unionBuoyUrl,
          disPlay
        } = res?.Data || {};
        console.log('res', res);
        /**
         * 显示浮窗的页面：首页、分类、商品详情页、到店、购物车、品牌详情页、商家详情页、门店列表页、订单列表页、订单详情页
         */
        if (isXcx && disPlay) {
          eHome.init({
            url: unionBuoyUrl || '',
            href: 'https://m.ejyshop.com/'
          });
        }
      });
    }, 250);
    debounceMX();
    return () => {
      debounceMX.cancel();
      eHome.clear();
    };
  }, [unionConfig, history.location.pathname]);

  const showMenu = routers.filter((item) => ('/newmovie' + item.path === window.location.pathname + '/' || '/newmovie' + item.path === window.location.pathname
    || '/movieh5' + item.path === window.location.pathname + '/' || '/movieh5' + item.path === window.location.pathname) && item.showMenu);
  const show = showMenu.length > 0 ? 'visible' : 'hidden';
  const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
  return (
    <React.Fragment>
      <CityCover type="city" />
      {/* <ActivityIndicator toast text="定位中..." animating={initLoading} /> */}
      <PersistGate persistor={window.g_app._store.persist}>
        <Spin tip={TLang('努力加载中', 'home', false, false, null)+'...'}spinning={loading} size="large">
          {
            <NavIndex visable={show} currentAddress={localAddress}>
              {props.children}
            </NavIndex>
          }
        </Spin>
      </PersistGate>
    </React.Fragment>
  );
};
export default connect((state: any) => ({ global: state.global, user: state.user, unionConfig: state.initData?.unionConfig }))(Layout);
